module.exports = __webpack_public_path__ + "img/logo2.887f9eee.png";